module.exports = __webpack_public_path__ + "static/media/marathon.dd588fa7.jpg";